export default __webpack_public_path__ + "static/Graphik-Semibold-Cy-Web-b62b55843bd9c3e83a64d92c485b152f.woff2";